import {useState} from 'react';
import usePostCreateCashBackOrderTransaction from '../../../../../services/hookService/postCreateCashBackOrderTransaction/usePostCreateCashBackOrderTransaction';
import usePostCreateCashBackStoreOrderTransaction from '../../../../../services/hookService/postCreateCashBackStoreOrderTransaction/usePostCreateCashBackStoreOrderTransaction';
import usePostCreateCreditOrderTransaction from '../../../../../services/hookService/postCreateCreditOrderTransaction/usePostCreateCreditOrderTransaction';
import usePostCreateCreditStoreOrderTransaction from '../../../../../services/hookService/postCreateCreditStoreOrderTransaction/usePostCreateCreditStoreOrderTransaction';
import {
  PaymentMethodValues,
  TransactionTypesChoices,
} from '../../../../shopping-basket/cash-payment/utils/helpers';

interface UsePostCreateCreditTransactionProps {
  transactionType?: TransactionTypesChoices;
  paymentType?: PaymentMethodValues;
  orderGuid?: string;
  storeOrderGuid?: string;
  enabled?: boolean;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export function usePostCreateCreditTransaction({
  transactionType,
  paymentType,
  orderGuid,
  storeOrderGuid,
  enabled = false,
  onSuccess,
  onError,
}: UsePostCreateCreditTransactionProps) {
  const [status, setStatus] = useState<string | null>(null);

  const handleSuccess = () => {
    setStatus('success');
    onSuccess?.();
  };

  const handleError = (error: any) => {
    setStatus('error');
    onError?.(error);
  };

  const creditOrderMutation = usePostCreateCreditOrderTransaction(
    handleSuccess,
    handleError,
  );

  const creditStoreOrderMutation = usePostCreateCreditStoreOrderTransaction(
    handleSuccess,
    handleError,
  );

  const cashBackOrderMutation = usePostCreateCashBackOrderTransaction(
    handleSuccess,
    handleError,
  );

  const cashBackStoreOrderMutation = usePostCreateCashBackStoreOrderTransaction(
    handleSuccess,
    handleError,
  );

  const isCashBackPayment =
    paymentType === PaymentMethodValues.CASHBACK_PAYMENT;
  //  || paymentType === PaymentMethodValues.CASHBACK_CASH_PAYMENT;
  // this or should normally be here but this is for when the user has more credit (cash back credit) than the order or store order total price. if it is not enough it will not call this hook at all

  const isOrder = transactionType === TransactionTypesChoices.ORDER;
  const isStoreOrder = transactionType === TransactionTypesChoices.STORE_ORDER;

  const isValidConfig =
    (isOrder && Boolean(orderGuid)) ||
    (isStoreOrder && Boolean(storeOrderGuid));

  const isLoading = isCashBackPayment
    ? isOrder
      ? cashBackOrderMutation.isLoading
      : cashBackStoreOrderMutation.isLoading
    : isOrder
    ? creditOrderMutation.isLoading
    : creditStoreOrderMutation.isLoading;

  const mutate = () => {
    if (!enabled || !isValidConfig) return;

    if (isOrder && orderGuid) {
      if (isCashBackPayment) {
        cashBackOrderMutation.mutate({order: orderGuid});
      } else {
        creditOrderMutation.mutate({order: orderGuid});
      }

      return;
    }

    if (isStoreOrder && storeOrderGuid) {
      if (isCashBackPayment) {
        cashBackStoreOrderMutation.mutate({
          store_order: storeOrderGuid,
        });
      } else {
        creditStoreOrderMutation.mutate({
          store_order: storeOrderGuid,
        });
      }
    }
  };

  return {
    mutate,
    status,
    isLoading,
    hasValidConfig: Boolean(transactionType) && isValidConfig,
  };
}
